/**
 * ProtectedRoute Component
 * 인증이 필요한 라우트를 보호하는 컴포넌트
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getItem } from '@/shared/utils/storage';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

/**
 * 인증이 필요한 라우트를 보호하는 컴포넌트
 * 인증되지 않은 사용자는 로그인 페이지로 리다이렉트
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const userId = getItem<string>('USER_ID');
  
  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  if (!userId) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;

